import React from 'react'

const CampaignBudget: React.FC = () => {
  return (
    <div className="flex justify-center bg-white rounded-lg p-8 pr-[74px] text-[#555] flex-col shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)]">
      <h1 className='text-base font-semibold mb-1'>Campaign budget</h1>
      <div className="flex justify-between mb-4">
        <input 
          type="text"
          placeholder='Lifetime Budget'
          className='w-[49%] border border-solid h-11 border-[#CCC] pl-3 outline-none rounded-lg placeholder:text-xs placeholder:font-normal placeholder:font-Poppins'  
        />
        <div 
          className="flex justify-between w-[49%] h-11 border border-solid border-[#ccc] items-center pl-3 pr-16 rounded-lg text-[#CCC] text-xs font-normal"
        >
          <h4>$700.00</h4>
          <h4>USD</h4>
        </div>
      </div>
      <p className='text-[13px] font-normal'>
        You won’t spend more than $700.00 
        during your lifetime of your campaign. 
        You ‘ll spend more on days with more opportunities
        and less on days with fewer opportunities. <span className='text-midGreen'>Learn more</span>
      </p>
      
      <h1 className='text-base font-semibold mt-8'>Ad scheduling</h1>
      <p className='text-xs font-normal mt-1'>You’ll set the specific schedule within each ad set.</p>
      <div className="flex items-center gap-3 text-sm font-normal mt-1">
        <input type="checkbox" className='h-6 w-6 rounded-sm border-[#555]' />
        <h3>Run ads on a schedule</h3>
      </div>
    </div>
  )
}

export default CampaignBudget;